module.exports = __webpack_public_path__ + "img/app.6ab5e6a8.svg";